import Vue from 'vue';
import BzbsApi from "@/core/Http/BzbsApi.js";
import { map } from 'rxjs/operators';
/**
 * @function getFriendLink
 */
export default {
    config: function () {
        return Vue.bzbsConfig;
    },

    getFriendLink: function (token) {
        var strUrl = this.config().bzbsUrl + "/referral/link";
        return BzbsApi.connectBzbsPost(strUrl, token, null).pipe(map((res) => {
            return res.data;
        }));
    },
}
